import { cn } from '@/lib/utils'

export function LogoIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 512 512"
      className={cn('h-7 w-7 shrink-0', className)}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Light mode gradient */}
        <linearGradient id="kgrad-logo-lm" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#A5B4FC" />
          <stop offset="100%" stopColor="#6366F1" />
        </linearGradient>
        {/* Dark mode gradient */}
        <linearGradient id="kgrad-logo-dm" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#818CF8" />
          <stop offset="100%" stopColor="#4F46E5" />
        </linearGradient>
      </defs>
      <style>{`
        .logo-lines { stroke: url(#kgrad-logo-lm); }
        .logo-node-corner { fill: #E0E7FF; }
        .logo-node-center { fill: #C7D2FE; }
        .logo-hint { stroke: #818CF8; stroke-opacity: 0.25; }
        .dark .logo-lines { stroke: url(#kgrad-logo-dm); }
        .dark .logo-node-corner { fill: #6366F1; }
        .dark .logo-node-center { fill: #4F46E5; }
        .dark .logo-hint { stroke: #6366F1; stroke-opacity: 0.18; }
      `}</style>
      <rect width="512" height="512" rx="96" className="fill-foreground" />
      <circle cx="256" cy="256" r="150" className="logo-hint" strokeWidth="4" fill="none" />
      <line x1="180" y1="120" x2="180" y2="392" className="logo-lines" strokeWidth="24" strokeLinecap="round" />
      <line x1="180" y1="256" x2="360" y2="120" className="logo-lines" strokeWidth="24" strokeLinecap="round" />
      <line x1="180" y1="256" x2="360" y2="392" className="logo-lines" strokeWidth="24" strokeLinecap="round" />
      <circle cx="180" cy="120" r="20" className="logo-node-corner" />
      <circle cx="180" cy="392" r="20" className="logo-node-corner" />
      <circle cx="360" cy="120" r="20" className="logo-node-corner" />
      <circle cx="360" cy="392" r="20" className="logo-node-corner" />
      <circle cx="180" cy="256" r="24" className="logo-node-center" />
    </svg>
  )
}
